import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { black, primaryColors } from './styles/colors';
import { label2 } from './typography';

const MuiMenuItem: Components<Omit<Theme, 'components'>>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      padding: '12px 16px',
      background: black['45%'],
      ...label2,
      color: primaryColors[500],
      select: {
        padding: 0,
      },
    },
  },
};

export default MuiMenuItem;
